import { Component, computed, inject } from '@angular/core';
import { TabViewChangeEvent } from 'primeng/tabview';
import { MetricsService } from '@portal/app/dashboard/context-modal/services/metrics.service';
import { ModalService } from '@portal/app/dashboard/context-modal/services/modal.service';
import { MetricsResponseDTO } from '@portal/app/dashboard/context-modal/context-model.types';

@Component({
  selector: 'portal-context-metrics',
  templateUrl: './metrics.component.html',
  styleUrls: ['./metrics.component.scss'],
  providers: [MetricsService]
})
export class MetricsComponent {
  metricsService = inject(MetricsService);
  private modalService = inject(ModalService);

  isLoading = this.metricsService.isLoading;
  data = this.metricsService.data;
  isDataAvailable = this.metricsService.isDataAvailable;
  activeTabIndex = this.metricsService.activeTabIndex;
  isSpendLevel = this.modalService.isSpendLevel;

  constructor() {
    this.metricsService.setActiveTabIndex(0);
  }

  onTabChange(event: TabViewChangeEvent): void {
    this.metricsService.setActiveTabIndex(event.index);
  }

  // Computed signal for filtered data based on spend level
  filteredData = computed(() => {
    const data = this.data();
    const isSpendLevel = this.isSpendLevel();

    if (isSpendLevel) {
      return data.filter(
        (metric: MetricsResponseDTO) => metric.literalId !== 'percInc'
      );
    }
    return data;
  });
}
